import React, {useEffect, useState} from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import CardSection from "./CardSection";
import axios from "axios";
import { ReactSession } from 'react-client-session';

const CheckoutForm = props => {
    const { stripe, elements } = props;
    const [loginForm, setLoginForm] = useState([])
    const [cardError, setCardError] = useState('')
    const [loadingSpinner, setLoadingSpinner] = useState(false)
    let [message, setMessage] = useState('');
    let [success, setSuccess] = useState(false);
    let [sessionId, setSessionId] = useState('');

    const planName = ReactSession.get("planName");
    const planFrequency = ReactSession.get("planFrequency");
    const planPrice = ReactSession.get("planPrice");
    const expiryDate = ReactSession.get("expiryDate");
    const renewalDate = ReactSession.get("renewalDate");
    const lookupKey = ReactSession.get("lookupKey");
    const priceId = ReactSession.get("priceId");
    const baseUrl = ReactSession.get("baseUrl");

    const handleSubmit = async (event) => {
        setLoadingSpinner(true)
        if (!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);
        if (result.error) {
            setLoadingSpinner(false)
            setCardError(result.error.message)
            console.log(result.error.message)
        } else {
            setCardError('')
            let data = new FormData();

            data.append('newPlanName', planName)
            data.append('newPlanFrequency', planFrequency)
            data.append('newPlanPrice', planPrice)
            data.append('payableAmount', planPrice)
            data.append('newPlanExpiryDate', expiryDate)
            data.append('newPlanRenewalDate', renewalDate)
            data.append('stripeToken', result.token.id)
            data.append('priceId', priceId)

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            axios.post(baseUrl + 'register-payment-process/', data, config)
                .then(r => {
                    setLoadingSpinner(false)
                    if (r.data.status === 'success') {
                        if( r.data.formData === 'true' )
                        {
                            setLoginForm([...loginForm, r.data.data]);
                            setTimeout(function (){
                                document.forms["frm"].submit();
                            }, 2000)
                        }
                        else{
                            window.location.reload();
                        }
                    } else if (r.data.status === 'failed') {
                        setCardError(r.data.msg)
                        console.log("Failed")
                    }
                })
        }
    };

    const handleStripe = async (event) => {
        setLoadingSpinner(true)
        if (!stripe || !elements) {
            return;
        }

        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);
        if (result.error) {
            setLoadingSpinner(false)
            setCardError(result.error.message)
            console.log(result.error.message)
        } else {
            setCardError('')
            let data = new FormData();

            data.append('lookup_key', lookupKey)
            data.append('stripeToken', result.token.id)
            console.log(data)

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            axios.post(baseUrl + 'create-checkout-session', data, config)
                .then(r => {
                    setLoadingSpinner(false)
                    const query = new URLSearchParams(r.data.checkoutSession.url);
                    if (query.get('success')) {
                        console.log("success")
                    }

                    if (query.get('canceled')) {
                        console.log("cancel")
                    }

                    if (r.data.checkoutSession.status === 'open') {
                        if (r.data.checkoutSession.success_url) {
                            setSuccess(true);
                            setSessionId(r.data.checkoutSession.id);
                        }
                        if (r.data.checkoutSession.cancel_url) {
                            setSuccess(false);
                            setMessage("Order canceled -- continue to shop around and checkout when you're ready.");
                        }
                        if (!success && message === '') {
                            window.location.reload();
                        } else if (success && sessionId !== '') {
                            if( r.data.formData === 'true' )
                            {
                                setLoginForm([...loginForm, r.data.data]);
                                setTimeout(function (){
                                    document.forms["frm"].submit();
                                }, 2000)
                            }
                            else{
                                window.location.reload();
                            }
                        } else {
                            setCardError(r.data.msg)
                        }

                    } else if (r.data.status === 'failed') {
                        setCardError(r.data.msg)
                        console.log("Failed")
                    }
                })
        }
    };

    useEffect(() => {
        // Check to see if this is a redirect back from Checkout
        const query = new URLSearchParams(window.location.search);

        if (query.get('success')) {
            setSuccess(true);
            setSessionId(query.get('session_id'));
        }

        if (query.get('canceled')) {
            setSuccess(false);
            setMessage(
                "Order canceled -- continue to shop around and checkout when you're ready."
            );
        }
    }, [sessionId]);

    return (
        <div>
            <div className="payment-card">
                <form method="POST">
                    <div className="payment-block">
                        <div className="product-info">
                            <h3 className="product-title">Payment Details</h3>
                        </div>
                        <span className={"red-block" + (cardError ? '' : ' hidden')}>{cardError}</span>
                        <CardSection/>
                    </div>
                    <div className="product-info">
                        <h3 className="product-title clearfix"><span className="left">Due {renewalDate}:</span><span
                            className="right"> ${planPrice}.00 </span></h3>
                        <h3 className="product-title clearfix"><span className="left"><strong>Due Today</strong> <span className="red">(30 days free)</span></span><span className="right"> $0.00</span></h3>
                    </div>
                    <input type="hidden" name="lookup_key" value={lookupKey} />
                    <div className={loadingSpinner ? "hidden" : ""}>
                        <a disabled={!props.stripe} className="registrationFormSubmitBtn btn btn-register-blue blue_bg"
                           onClick={() => handleSubmit()}>
                            Get your free trial
                        </a>
                    </div>
                    <div className={loadingSpinner ? "" : "hidden"}>
                        <button className="btn btn-register-blue" id="startMyFreeTrialBtn"><i className="fa fa-spinner fa-spin" style={{"margin-left": "-12px", "margin-right": "8px"}}></i>Get your free trial
                        </button>
                    </div>
                </form>
                <form className='form' action={ baseUrl + 'login_check'} method='POST' id='frm'>
                    <div className={"loginForm"} dangerouslySetInnerHTML={{__html: loginForm}}>
                    </div>
                </form>
            </div>

            <form className='form' action={ baseUrl + 'login_check'} method='POST' id='frm'>
                <div className={"loginForm"} dangerouslySetInnerHTML={{ __html: loginForm }}>
                </div>
            </form>

        </div>
    );
}

export default function InjectedCheckoutForm() {
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <CheckoutForm stripe={stripe} elements={elements} />
            )}
        </ElementsConsumer>
    );
}